module.exports = __webpack_public_path__ + "fruits-min.png?84106c27b25b17098d638b94505f2423";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fruits-min.png
// module id = 37
// module chunks = 0